import React from 'react';
import { IconProps } from '../../DefaultIcon';
export function IRSTypesIcon({ className }: IconProps) {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2098)">
        <path
          d="M71.5788 10.2897H15.4209C14.342 10.2897 13.4473 9.39492 13.4473 8.31597C13.4473 7.23702 14.342 6.34229 15.4209 6.34229H71.5788C72.6578 6.34229 73.5525 7.23702 73.5525 8.31597C73.5525 9.39492 72.6578 10.2897 71.5788 10.2897Z"
          fill="#EAEEF9"
        />
        <path
          d="M43.5002 0C39.1317 0 35.5791 3.55263 35.5791 7.92105V75.9474H51.3949V7.92105C51.3949 3.55263 47.8423 0 43.5002 0Z"
          fill="#EAEEF9"
        />
        <path
          d="M47.4475 8.31602C47.4475 10.5002 45.6843 12.2634 43.5001 12.2634C41.3159 12.2634 39.5527 10.5002 39.5527 8.31602C39.5527 6.13181 41.3159 4.36865 43.5001 4.36865C45.6843 4.36865 47.4475 6.13181 47.4475 8.31602Z"
          fill="#00416B"
        />
        <path
          d="M26.8948 52.1842C26.2106 52.1842 25.579 51.7368 25.3685 51.0526L14.6317 14L3.89483 51.0526C3.65799 51.8947 2.76325 52.3684 1.94746 52.1316C1.10536 51.8947 0.631673 51 0.868515 50.1842L13.1054 7.8684C13.3159 7.18419 13.9211 6.73682 14.6317 6.73682C15.3422 6.73682 15.9475 7.2105 16.158 7.8684L28.4211 50.1842C28.658 51.0263 28.1843 51.8947 27.3422 52.1316C27.1843 52.1842 27.0527 52.1842 26.8948 52.1842Z"
          fill="#00C4B3"
        />
        <path
          d="M84.6048 52.1842C83.9206 52.1842 83.289 51.7368 83.0785 51.0526L72.3416 14L61.6048 51.0526C61.3679 51.8947 60.4732 52.3684 59.6574 52.1316C58.8153 51.8947 58.3416 51 58.5785 50.1842L70.8416 7.8684C71.0258 7.18419 71.6574 6.73682 72.3679 6.73682C73.0785 6.73682 73.6837 7.2105 73.8943 7.8684L86.1574 50.1842C86.3943 51.0263 85.9206 51.8947 85.0785 52.1316C84.9206 52.1842 84.789 52.1842 84.6311 52.1842"
          fill="#00C4B3"
        />
        <path
          d="M76.3156 8.31602C76.3156 10.5002 74.5525 12.2634 72.3683 12.2634C70.1841 12.2634 68.4209 10.5002 68.4209 8.31602C68.4209 6.13181 70.1841 4.36865 72.3683 4.36865C74.5525 4.36865 76.3156 6.13181 76.3156 8.31602Z"
          fill="#00416B"
        />
        <path
          d="M18.5793 8.31602C18.5793 10.5002 16.8161 12.2634 14.6319 12.2634C12.4477 12.2634 10.6846 10.5002 10.6846 8.31602C10.6846 6.13181 12.4477 4.36865 14.6319 4.36865C16.8161 4.36865 18.5793 6.13181 18.5793 8.31602Z"
          fill="#00416B"
        />
        <path
          d="M68.3944 81.4473H18.5786C17.0523 81.4473 15.8154 82.6841 15.8154 84.2104C15.8154 85.7367 17.0523 86.9736 18.5786 86.9736H68.3944C69.9207 86.9736 71.1575 85.7367 71.1575 84.2104C71.1575 82.6841 69.9207 81.4473 68.3944 81.4473Z"
          fill="#EAEEF9"
        />
        <path
          d="M58.5267 75.9209H28.4741C26.9478 75.9209 25.7109 77.1577 25.7109 78.6841C25.7109 80.2104 26.9478 81.4472 28.4741 81.4472H58.5267C60.053 81.4472 61.2899 80.2104 61.2899 78.6841C61.2899 77.1577 60.053 75.9209 58.5267 75.9209Z"
          fill="#00C4B3"
        />
        <path
          d="M28.4737 49.8159H0.789474C0.342105 49.8159 0 50.1843 0 50.6054C0 56.7107 4.94737 61.6843 11.0789 61.6843H18.1842C24.2895 61.6843 29.2632 56.737 29.2632 50.6054C29.2632 50.158 28.8947 49.8159 28.4737 49.8159Z"
          fill="#00C4B3"
        />
        <path
          d="M86.211 49.8159H58.5268C58.0794 49.8159 57.7373 50.1843 57.7373 50.6054C57.7373 56.7107 62.6847 61.6843 68.8162 61.6843H75.9478C82.0531 61.6843 87.0268 56.737 87.0268 50.6054C87.0268 50.158 86.6584 49.8159 86.2373 49.8159"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2098">
          <rect width="87" height="87" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
